module.exports = __webpack_public_path__ + "img/img-adaa0a88.d2c7abad.png";